module.exports = __webpack_public_path__ + "img/red-glow.2f07bc8e.svg";